import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "infographics-container" }
const _hoisted_3 = { class: "infographics-header-block text-center" }
const _hoisted_4 = { class: "infographics-logo" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", null, "CONVORALLY", -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "step-tab" }
const _hoisted_8 = { class: "step-content" }
const _hoisted_9 = { class: "box-container scrollable" }
const _hoisted_10 = { class: "log-button text-center" }
const _hoisted_11 = { class: "uppercase-text" }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = { class: "to-upper" }
const _hoisted_15 = { class: "create-account text-center" }
const _hoisted_16 = { class: "create-img" }
const _hoisted_17 = { class: "create-text" }
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 9umbers, and $ymbol$)")
const _hoisted_21 = { class: "login-signin" }
const _hoisted_22 = { class: "bulb-img" }
const _hoisted_23 = { class: "login-signin-desc" }
const _hoisted_24 = { class: "quick-login" }
const _hoisted_25 = { class: "login-img-wrap" }
const _hoisted_26 = { class: "login-social" }
const _hoisted_27 = { class: "login-social" }
const _hoisted_28 = { class: "quick-signin" }
const _hoisted_29 = { class: "signin-img text-center" }
const _hoisted_30 = { class: "uppercase-text" }
const _hoisted_31 = { class: "sign-text align-self-center" }
const _hoisted_32 = { class: "step-move" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "step-prev disabled" }, [
  /*#__PURE__*/_createVNode("a", { href: "#" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" })
  ])
], -1)
const _hoisted_34 = { class: "step-next" }
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_36 = { class: "login-note" }
const _hoisted_37 = { class: "final-container" }
const _hoisted_38 = { class: "final-block" }
const _hoisted_39 = { class: "container" }
const _hoisted_40 = { class: "final-wrap" }
const _hoisted_41 = { class: "convorally-moto" }
const _hoisted_42 = { class: "italic" }
const _hoisted_43 = { class: "final-img-wrap" }
const _hoisted_44 = /*#__PURE__*/_createVNode("p", null, "www. ", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("p", null, ".com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")
  const _component_TutorialStep = _resolveComponent("TutorialStep")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convoicon-blue.png`: 'timg/convoicon-blue.png' ,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _hoisted_5,
        _createVNode("h2", null, _toDisplayString(_ctx.$t('project_manager_app')), 1),
        _createVNode(_component_P, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('project_manager_description')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_TutorialStep)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("button", _hoisted_11, _toDisplayString(_ctx.$t('login')), 1),
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/hand-pointer.png`: 'timg/hand-pointer.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('access_your')) + " ", 1),
                _hoisted_12,
                _hoisted_13,
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('project_manager')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/login-settings.png`: 'timg/login-settings.png' ,
                  alt: ""
                }, null, 8, ["src"]),
                _createVNode("h3", null, _toDisplayString(_ctx.$t('create_an_account')), 1)
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_P, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('use_a_custom_username_password_to_login_into_your_project_manager')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_P, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('use_strong_password_using_a_combination_of')) + " ", 1),
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('uppercase_lowercase_letters')) + ", ", 1),
                    _hoisted_19,
                    _hoisted_20
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/bulb.png`: 'timg/bulb.png' ,
                  alt: ""
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("h4", null, _toDisplayString(_ctx.$t('quick_login')), 1),
                  _createVNode(_component_P, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('sign_in_using')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, [
                      _createVNode("img", {
                        src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/g-mail.jpg`: 'timg/g-mail.jpg' ,
                        alt: ""
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("div", _hoisted_27, [
                      _createVNode("img", {
                        src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/facebook.jpg`: 'timg/facebook.jpg' ,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("img", {
                      src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/signin.png`: 'timg/signin.png' ,
                      alt: ""
                    }, null, 8, ["src"]),
                    _createVNode("h4", _hoisted_30, _toDisplayString(_ctx.$t('sign_in')), 1)
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('sign_in_using_your_username_and_password')), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode("div", _hoisted_34, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep2 && _ctx.redirectToStep2(...args)))
              }, [
                _hoisted_35
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_36, [
          _createVNode("p", null, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('noite')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('you_will_receive_a_verification_email_after_signing_up_with_convorally')), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode("section", _hoisted_38, [
        _createVNode("div", _hoisted_39, [
          _createVNode("div", _hoisted_40, [
            _createVNode("div", _hoisted_41, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/comment.png`: 'timg/comment.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('building_confidence_trust')) + " – ", 1),
                _createVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('one_convo_at_a_time')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_43, [
              _hoisted_44,
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convorally-text.png`: 'timg/convorally-text.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _hoisted_45
            ])
          ])
        ])
      ])
    ])
  ]))
}